"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _LifecycleRules_1 = require("./_LifecycleRules");
exports.GetBucketLifecycleConfigurationOutput = {
    type: "structure",
    required: [],
    members: {
        Rules: {
            shape: _LifecycleRules_1._LifecycleRules,
            locationName: "Rule"
        }
    }
};
//# sourceMappingURL=GetBucketLifecycleConfigurationOutput.js.map